import { useQuery } from "@apollo/client";
import { GET_GENERATION_TEMPLATE_BY_ID } from "../gql";
import type { GenerationTemplate } from "@casey/db-types";

interface UseGenerationTemplateResult {
  template: GenerationTemplate | null;
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useGenerationTemplate(
  agentId: string | null | undefined,
  options: { skip?: boolean } = {},
): UseGenerationTemplateResult {
  const { skip } = options;

  const { data, loading, error, refetch } = useQuery<{
    generationTemplate: GenerationTemplate | null;
  }>(GET_GENERATION_TEMPLATE_BY_ID, {
    variables: { id: agentId },
    skip: skip || !agentId,
    errorPolicy: "all",
  });

  return {
    template: data?.generationTemplate || null,
    loading,
    error: error || null,
    refetch,
  };
}
